import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {  MatDialog,  MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { mapTo, switchMap } from 'rxjs/operators';
import { CompanyinboxService } from '../../../../results/inboxintel/companies/services/companyinbox.service';
import { InboxintelService } from '../../../../results/inboxintel/services/inboxintel.service';
import { ContactinboxService } from '../../../../results/inboxintel/contacts/services/contactinbox.service';
import { InboxintelDeauthorizationComponent } from '../inboxintel-deauthorization/inboxintel-deauthorization.component';
import { UserService } from '../../../../core/services/user.service';
import { User } from '../../../../core/models/user.model';
import { LoadingService } from '../../../../shared/services';
import { AuthenticationService } from '../../../../core/services/authentication.service';

const LOADING_TAG: string = 'inboxintel-settins-loading-tag';

@UntilDestroy()
@Component({
    selector: 'app-inboxintel-settings-modal',
    templateUrl: './inboxintel-settings-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InboxIntelSettingsModalComponent implements OnInit {
    readonly isLoading$: Observable<boolean> = this.loadingService.getIsLoading(LOADING_TAG);

    userData: User;
    oAuthUserId;
    constructor(
        private readonly userService: UserService,
        private readonly matDialog: MatDialog,
        private readonly inboxIntelService: InboxintelService,
        private readonly toastr: ToastrService,
        private readonly companyInboxService: CompanyinboxService,
        private readonly contactInboxService: ContactinboxService,
        private readonly matDialogRef: MatDialogRef<InboxIntelSettingsModalComponent>,
        private readonly loadingService: LoadingService,
        private readonly authenticationService: AuthenticationService,
    ) { }

    ngOnInit(): void {
        this.userService.getUserData().pipe(untilDestroyed(this)).subscribe((user: User) => {
            this.userData = user;
        });
        this.oAuthUserId = sessionStorage.getItem('oAuthUserId');
    }
    close() {
        this.matDialogRef.close();
    }
    deauthorize() {
        const initialConfig = {
            panelClass: 'modal-md',
            data: {
                email: this.userData.email
            }
        };
        this.matDialog.open(InboxintelDeauthorizationComponent, initialConfig).afterClosed().pipe(untilDestroyed(this)).subscribe((success: boolean) => {
            if (success) {
                this.deAuthorizeInboxIntel().pipe(
                    switchMap((res) => {
                        if (res.response === 'Success.') {
                            return this.authenticationService.updateLoggedUserDataObservable().pipe(mapTo(res))
                        }
                        return of(res);
                    }),
                    untilDestroyed(this)
                ).subscribe((res) => {
                    if (res.response === 'Success.') {
                        sessionStorage.removeItem('externalPrincipalId');
                        sessionStorage.removeItem('oAuthUserId');
                        this.inboxIntelService.externalPrincipalId = '';
                        this.inboxIntelService.enableAuthentication = true;
                        this.inboxIntelService.hasInboxIntel = false;
                        this.companyInboxService.resultPage.resultData = [];
                        this.contactInboxService.resultPage.resultData = [];
                        this.toastr.success('InboxIntel Deauthorized Successfully');
                        this.close();
                    }
                });
            }
        });
    }

    private deAuthorizeInboxIntel() {
        return this.loadingService.loadingWrapper(this.companyInboxService.deAuthorizeInboxIntel(), LOADING_TAG);
    }
}
